<template>
  <sui-page>
    <sui-page-header :pageId="this.$options.name" />
    <sui-page-contents>
      <div class="comm_scr_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_SITE')"
              :vertical="false"
              :required="true"
            />
          </div>
          <div class="col-xs-5">
            <sui-custom-select
              ref="siteSelect"
              :selected="selectedCode.SIT"
              :defaultOption="'all'"
              :option-list="siteList"
              @list-clicked="onListClicked"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_TASK_TYPE')"
              :vertical="false"
              :required="true"
            />
          </div>
          <div class="col-xs-5">
            <cmp-task-id-select
              ref="taskIdSelect"
              :default1LevelOption="'all'"
              :default2LevelOption="'all'"
              :default3LevelOption="'all'"
              :pageId="this.$options.name"
              :applyAuthSiteId="this.applyAuthSiteId"
              @select-changed="onChangeBizCodes"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_APPR_STT')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-code-select
              ref="apprSttSelect"
              :selected="selectedCode.COD_AUTH_RQS_STT"
              codeId="COD_AUTH_RQS_STT"
              :defaultOption="'all'"
              :filteredOptionList="filteredOptionList"
            />
          </div>       
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_USER_GROUP')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-text-field
              v-model="userGroupName"
              :disabled="false"
              :readonly="false"
              maxlength="50"
              @keyup.enter="onSearch"
            />
          </div>
          </div>
          <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_CORP_NAME')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-text-field
              v-model="applCompany"
              maxlength="50"
              @keyup.enter="onSearch"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_APPL_USR_ID')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-text-field
              v-model="loginId"
              maxlength="50"
              @keyup.enter="onSearch"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_APPL_USER')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-text-field
              v-model="applUser"
              maxlength="50"
              @keyup.enter="onSearch"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_APPL_DATE')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-range-date-picker
              ref="dp"
              v-model="selectedCode.rangeDate"
              @confirm="onRangeConfirm"
            />
          </div>
        </div>
        <div class="btn_wrap">
          <sui-button
            type="button"
            class="comm_btn_Reset"
            @click="onReset"
          >
            {{ $t('MSG_BTN_RESET') }}
          </sui-button>
          <sui-button
            v-permission:read="'PGE_CMA_00010'"
            type="button"
            class="comm_btn_Scr"
            @click="onSearch"
          >
            {{ $t('MSG_BTN_SEARCH') }}
          </sui-button>
        </div>
      </div>
      <div class="mrB30" />
      <sui-grid
        ref="grdList"
        :showCountControl="true"
        :showDisplayCountControl="false"
        :pageable="false"
        :sortable="false"
        :filterable="false"
        :columns="gridColumns"
        :columnsresize="true"
        :columnsautoresize="true"
        :enabletooltips="true"
        width="100%"
        :dataset="'dsData'"
        :initialPagesize="10"
        @columnclick="onSelectAll"
      />
      <div class="comm_btn_wrap">
        <sui-button
          type="button"
          class="comm_btn_border"
          :disabled="rejectDisable"
          @click="onReject"
        >
          {{ $t('MSG_BTN_RJT') }}
        </sui-button>
        <sui-button
          type="button"
          class="comm_btn_solid"
          :disabled="apprDisable"
          @click="onApprove"
        >
          {{ $t('MSG_BTN_APPR') }}
        </sui-button>
      </div>
      <sui-popup
        v-model="showFinDtPopup"
        :title="$t('MSG_TIT_AUTH_APPR')"
      >
        <finDtPopup
          :parentPageId="this.$options.name"
          @confirm="onPopupConfirmClicked"
          @cancel="onPopupCancelClicked"
        />
      </sui-popup>
    </sui-page-contents>
  </sui-page>
</template>
<script>
// import - libraries (node modules)
import finDtPopup from './components/PGE_CMA_00010_P01';
// import - local files (js, vue, ...)
// 페이지 에서 사용하는 code 목록 기술
export default {
  name: 'PGE_CMA_00010', // eslint-disable-line vue/name-property-casing
  components: {
    finDtPopup,
  },
  data() {
    return {
      showFinDtPopup: false,
      applUser: '',
      applCompany: '',
      loginId: '',
      applyAuthSiteId: 'ALL',
      allSelect: false,
      apprDisable: false,
      rejectDisable: false,
      siteList: [],
      authRequestOptionList: [],
      compAuthOptionList: [],
      filteredOptionList: [
        {key: "ALL"},
        {key: "S"},
        {key: "A"},
        {key: "R"},
      ],
      selCodes: CommonConstants.selectOptions(),
      userInfo: {},
      count: 0,
      selectedCode: {
        SIT: { key: '', label: '', taskId: '' },
        COD_AUTH_RQS_STT: { key: 'S', label: '' },
        rangeDate: {
          from: '',
          to: '',
        },
      },
      searchFieldOldText: '',
      selectedUser: { userName: '', userId: '' },
      userGroupName: '',
      localdata0: [],
      gridColumns: [
        {
          text: '',
          datafield: 'check',
          align: 'center',
          width: '40',
/*
          renderer(elem) {
            console.log(elem);
            return '<div id="checkbox" style="z-index: 999; margin-top: 8px; margin-left:8px" @click="onSelectAll"></div>';
          },
          rendered(element, align, height) {
            console.log(align);
            console.log(height);
            element.jqxCheckBox();
          },
*/
          createwidget: (row, column, value, htmlElement) => {
            utils.getGridCellFactory().createCellCheckbox(row, column, value, htmlElement, {
            }, this.dsData, this.$refs.grdList);
          },
          initwidget(row, column, value, htmlElement) {
            utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
          },
        },
        {
          text: this.$t('MSG_TXT_SITE'),
          datafield: 'siteName',
          width: 80,
        },
        {
          text: this.$t('MSG_TXT_GBM'),
          datafield: 'gbmName'
        },
        {
          text: this.$t('MSG_TXT_TASK_TYPE'),
          datafield: 'taskName',
        },
        {
          text: this.$t('MSG_TXT_USER_GROUP'),
          datafield: 'userGroupName',
        },
        {
          text: this.$t('MSG_TXT_APPL_USR_ID'),
          datafield: 'requestLoginId',
          width: 100,
        },
        {
          text: this.$t('MSG_TXT_APPL_USER'),
          datafield: 'requestUserId',
          createwidget: (row, column, value, htmlElement) => {
            utils.getGridCellFactory().createCellUserName(row, column, value, htmlElement, {
              displayType: '1', // "1", "2" - default: "1"
              type: 'link', // 'link', 'sublink' - default: "link"
              datafieldMap: {
                displayLanguageId: 'requestDsplLangId',
                knoxId: 'requestKnoxId',
                userName: 'requestUserName',
                userGlobalName: 'requestUserGlobalName',
              },
            }, this.dsData, this.$refs.grdList);
          },
          initwidget(row, column, value, htmlElement) {
            utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
          },
          width: 100,
        },
        {
          text: this.$t('MSG_TXT_CORP_NAME'),
          datafield: 'requestCompanyName',
          width: 150,
        },
        {
          text: this.$t('MSG_TXT_APPL_DTM'),
          datafield: 'requestDTM',
          width: 100,
        },
        {
          text: this.$t('MSG_TXT_VEND_APPR_RESULT'),
          datafield: 'companyAuthReviewStatusCode',
          createwidget: (row, column, value, htmlElement) => {
            utils.getGridCellFactory().createCellBadge(row, column, value, htmlElement, {
              optionList: this.compAuthOptionList, handler: this.onViewRjtOpn,
            }, this.dsData, this.$refs.grdList);
          },
          initwidget(row, column, value, htmlElement) {
            utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
          },
          width: 80,
        },
        {
          text: this.$t('MSG_TXT_APPR_STT'),
          datafield: 'authRequestStatusCode',
          createwidget: (row, column, value, htmlElement) => {
            utils.getGridCellFactory().createCellBadge(row, column, value, htmlElement, {
              optionList: this.authRequestOptionList, handler: this.onViewRjtOpn,
            }, this.dsData, this.$refs.grdList);
          },
          initwidget(row, column, value, htmlElement) {
            utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
          },
          width: 80,
        },
        {
          text: this.$t('MSG_TXT_MST_APPR_YN'),
          datafield: 'masterUserYn',
          createwidget: (row, column, value, htmlElement) => {
            utils.getGridCellFactory().createCellSegmentBox(row, column, value, htmlElement, {
              checkDisabledFunction: (rowData) => !(rowData.authRequestStatusCode === 'S' &&        //요청
                                                    rowData.companyAuthReviewStatusCode !== '02'),  //비대상
            }, this.dsData, this.$refs.grdList);
          },
          initwidget(row, column, value, htmlElement) {
            utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
          },
          width: 80,
        },
        {
          text: this.$t('MSG_TXT_APPR_RJT_USER'),
          datafield: 'authUserId',
          createwidget: (row, column, value, htmlElement) => {
            if (utils.isEmpty(row.bounddata.authUserId) === false) {
              utils.getGridCellFactory().createCellUserName(row, column, value, htmlElement, {
                displayType: '1', // "1", "2" - default: "1"
                type: 'link', // 'link', 'sublink' - default: "link"
                datafieldMap: {
                  displayLanguageId: 'authDsplLangId',
                  knoxId: 'authKnoxId',
                  userName: 'authUserName',
                  userGlobalName: 'authUserGlobalName',
                },
              }, this.dsData, this.$refs.grdList);
            }
          },
          initwidget(row, column, value, htmlElement) {
            utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
          },
          width: 100,
        },
        {
          text: this.$t('MSG_TXT_APPR_RJT_USER_DTM'),
          datafield: 'authApprDTM',
          width: 100,
        },
        {
          text: this.$t('MSG_TXT_VALID_PERIOD'),
          datafield: 'validFinishDT',
          width: 150,
          createwidget: (r, c, v, h) => utils.getGridCellFactory().createCellDateLabel(r, c, v, h, { formatOption: 'S' }, this.dsData, this.$refs.grdList),
          initwidget: (r, c, v, h) => utils.getGridCellFactory().refreshCell(r, c, v, h),
        },
      ],
    };
  },
  computed: {},
  watch: {},
  datasets: [{
    id: 'dsData',
    type: 'local',
    data: 'localdata0',
    datafields: [
      // { name: 'dataset-row-id', type: 'string', map: 'dataset-row-id' },
      { name: 'check', type: 'string', map: 'check' },
      { name: 'siteId', type: 'string', map: 'siteId' },
      { name: 'siteName', type: 'string', map: 'siteName' },
      { name: 'gbmName', type: 'string', map: 'gbmName' },
      { name: 'taskId', type: 'string', map: 'taskId' },
      { name: 'taskName', type: 'string', map: 'taskName' },
      { name: 'userGroupId', type: 'string', map: 'userGroupId' },
      { name: 'userGroupName', type: 'string', map: 'userGroupName' },
      { name: 'requestLoginId', type: 'string', map: 'requestLoginId' },
      { name: 'requestUserId', type: 'string', map: 'requestUserId' },
      { name: 'requestUserName', type: 'string', map: 'requestUserName' },
      { name: 'requestUserGlobalName', type: 'string', map: 'requestUserGlobalName' },
      { name: 'requestDeptId', type: 'string', map: 'requestDeptId' },
      { name: 'requestDeptName', type: 'string', map: 'requestDeptName' },
      { name: 'requestDeptGlobalName', type: 'string', map: 'requestDeptGlobalName' },
      { name: 'requestDsplLangId', type: 'string', map: 'requestDsplLangId' },
      { name: 'requestKnoxId', type: 'string', map: 'requestKnoxId' },
      { name: 'requestCompanyName', type: 'string', map: 'requestCompanyName' },
      { name: 'button', type: 'string', map: 'button' },
      { name: 'authRequestReason', type: 'string', map: 'authRequestReason' },
      { name: 'authApprDTM', type: 'string', map: 'authApprDTM' },
      { name: 'authRequestStatusCode', type: 'string', map: 'authRequestStatusCode' },
      { name: 'authRequestStatusName', type: 'string', map: 'authRequestStatusName' },
      { name: 'authRejectUserId', type: 'string', map: 'authRejectUserId' },
      { name: 'authRejectReason', type: 'string', map: 'authRejectReason' },
      { name: 'authRejectDtm', type: 'string', map: 'authRejectDtm' },
      { name: 'authRejectUserIp', type: 'string', map: 'authRejectUserIp' },
      { name: 'authUserId', type: 'string', map: 'authUserId' },
      { name: 'authUserName', type: 'string', map: 'authUserName' },
      { name: 'authUserGlobalName', type: 'string', map: 'authUserGlobalName' },
      { name: 'authDsplLangId', type: 'string', map: 'authDsplLangId' },
      { name: 'authKnoxId', type: 'string', map: 'authKnoxId' },
      { name: 'authRequestUid', type: 'string', map: 'authRequestUid' },
      { name: 'requestDTM', type: 'string', map: 'requestDTM' },
      { name: 'companyAuthReviewStatusCode', type: 'string', map: 'companyAuthReviewStatusCode' },
      { name: 'masterUserYn', type: 'string', map: 'masterUserYn' },
      { name: 'validFinishDT', type: 'string', map: 'validFinishDT' },
    ],
  }],
  mounted() {
    this.userInfo = this.$store.getters.userInfo;
    this.loadCode();
    // this.loadCode('COD_COMP_AUTH_REVW_STT', this.compAuthOptionList);
    this.load();
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    loadCode() {
       const codeKeys = ['COD_AUTH_RQS_STT','COD_COMP_AUTH_REVW_STT'];
       const codes = {
          COD_AUTH_RQS_STT : [{ label: '', key: '' }],
          COD_COMP_AUTH_REVW_STT : [{ label: '', key: '' }],
       };

       return http.mergeCodeList(this.$options.name, codeKeys, codes).then(res => {
//         optionList = [];
         utils.forEach(res.COD_AUTH_RQS_STT, item => {
           let codeType = '';
           let clickable = '';
           switch (item.key) {
             case 'S':
               // 신청
               codeType = 'waiting';
               clickable = '';
               break;
             case 'A':
               // 승인
               codeType = 'complete';
               clickable = '';
               break;
             case 'R':
               // 반려
               codeType = 'cancel';
               clickable = 'true';
               break;
            case 'W':
               // 회수
               codeType = 'cancel';
               clickable = '';
               break;
            case 'Z':
               // 신청취소
               codeType = 'cancel';
               clickable = '';
               break;
             default:
               break;
           }
           this.authRequestOptionList.push({
             label: item.label,
             key: item.key,
             type: codeType,
             clickable,
           });
         });
         utils.forEach(res.COD_COMP_AUTH_REVW_STT, item => {
           let codeType = '';
           let clickable = '';
           switch (item.key) {
             case '01':
               // 미검토
               codeType = 'waiting';
               clickable = '';
               break;
            case '02':
               // 비대상
               codeType = 'cancel';
               clickable = '';
               break;
             case '03':
               // 승인
               codeType = 'complete';
               clickable = '';
               break;
             case '04':
               // 반려
               codeType = 'cancel';
               clickable = '';
               break;
             default:
               break;
           }
           this.compAuthOptionList.push({
             label: item.label,
             key: item.key,
             type: codeType,
             clickable,
           });
         });
       }).catch(error => {
         console.log(error);
       });
    },
    load() {
      http.request(this.$options.name, 'DTS_CMA_00039', {
      }).then(res => {
        this.siteList = [];
        if (res.data.length > 0) {
          utils.forEach(res.data, obj => {
            const siteInfo = {
              key: obj.siteId,
              label: obj.siteName,
              taskId: obj.taskId,
            };
            this.siteList.push(siteInfo);
          });
        }
        this.selectedCode.SIT.key = 'ALL';
      }).catch(error => {
        console.log(error);
      });
    },
    onChangeBizCodes(optList) {
      this.selectedBizCode = optList;
    },
    onSelectedUser(selectedData) {
      if (selectedData !== null) {
        this.selectedUser.userName = selectedData.userName;
        this.selectedUser.userId = selectedData.userId;
      } else {
        this.selectedUser.userName = '';
        this.selectedUser.userId = '';
      }
    },
    onRangeConfirm(value) {
      this.selectedCode.rangeDate = utils.assign(value);
    },
    onViewRjtOpn(value, dataRow) {
      const inputValue = dataRow.authRejectReason;
      utils.openTextAreaEditor(
        this.onClosePopup,
        {
          title: this.$t('MSG_TXT_AUTH_APPL_RSN'),
          pageInitialData: {
            readonly: true,
            value: inputValue,
            positiveButtonText: this.$t('MSG_BTN_CFRM'),
          },
        },
      );
    },
    onViewApplOpn(stateOption, dataRow) {
      let inputValue = '';
      if (dataRow != null) {
        inputValue = dataRow.authRequestReason;
      }
      utils.openTextAreaEditor(
        this.onClosePopup,
        {
          title: this.$t('MSG_TIT_AUTH_APPL_RJT_RSN'),
          pageInitialData: {
            readonly: true,
            value: inputValue,
            positiveButtonText: this.$t('MSG_BTN_CFRM'),
          },
        },
      );
    },
    onKeyUpInput() {
      const searchFieldNewText = this.userGroupName;

      if (utils.isEmpty(searchFieldNewText) === false) {
        if (utils.isExistSpecialChar(searchFieldNewText) === true) {
          this.conFirm('error', this.$t('MSG_ALT_NO_SPECL_CHAR'), null);
          this.userGroupName = this.searchFieldOldText;
        } else {
          this.searchFieldOldText = searchFieldNewText;
        }
      }
    },
    onReset() {
      this.applyAuthSiteId = 'ALL';
      this.$refs.siteSelect.reset();
      this.$refs.taskIdSelect.reset('ALL');
      this.selectedBizCode = [];
      this.$refs.apprSttSelect.reset();
      this.userGroupName = '';
      this.selectedUser.userName = '';
      this.selectedUser.userId = '';
      this.selectedCode.rangeDate = {
        from: '',
        to: '',
      };
      this.loginId = '';
      this.applUser = '';
      this.applCompany = '';
    },
    onSearch() {
      if (this.onClickValidate()) return false;
/*
      if ((this.selectedCode.SIT.key === ' ')
          || (utils.isEmpty(this.selectedCode.SIT.key) === true)) {
        const msg = utils.strFormat(this.$t('MSG_ALT_NCELL_REQUIRED_VAL'), this.$t('MSG_TXT_SITE'));
        utils.messageBox('warning', msg);
        return;
      }
*/
      const siteId = this.selectedCode.SIT.key === 'ALL'
        ? '' : this.selectedCode.SIT.key;

      let taskId = '';
      if (this.selectedBizCode.length === 3) {
        if (this.selectedBizCode[2].key !== 'ALL') {
          taskId = utils.trim(this.selectedBizCode[2].key);
        } else if (this.selectedBizCode[1].key !== 'ALL') {
          taskId = utils.trim(this.selectedBizCode[1].key);
        } else if (this.selectedBizCode[0].key !== 'ALL') {
          taskId = utils.trim(this.selectedBizCode[0].key);
        }
      }

/*
      if (utils.isEmpty(taskId) === true) {
        const msg = utils.strFormat(this.$t('MSG_ALT_NCELL_REQUIRED_VAL'), this.$t('MSG_TXT_TASK_TYPE'));
        utils.messageBox('warning', msg);
        return;
      }
*/
      const apprSttCode = this.selectedCode.COD_AUTH_RQS_STT.key === 'ALL'
        ? '' : this.selectedCode.COD_AUTH_RQS_STT.key;
      const { from, to } = this.selectedCode.rangeDate;

      const reqFrom = utils.toStringByFormat(from, 'YYYYMMDD');
      const reqTo = utils.toStringByFormat(to, 'YYYYMMDD');

      const queryParams = {
        portalId: 'PEHS',
        siteId: siteId || '',
        taskId: taskId || '',
        apprSttCode: apprSttCode || '',
        userGroupName: this.userGroupName || '',
        userId: this.loginId || '',
        applUser: this.applUser || '',
        applCompany: this.applCompany || '',
        reqFrom: reqFrom || '',
        reqTo: reqTo || '',
        apprSttCodeFilter: 'S;A;R',
      };

      http.request(this.$options.name, 'DTS_CMA_00038', {
        query: queryParams,
      }).then(res => {
        const items = [];
        utils.forEach(res.data, item => {
          const apprDTM = utils.isEmpty(item.authApprovalDTM) === true
            ? '-' : utils.dateformatToClient(item.authApprovalDTM);
          const requestDTM = utils.dateformatToClient(item.firstRegistrationDTM);
          const check = item.authRequestStatusCode === 'S' ? 'N' : 'O';
          const button = item.authRequestStatusCode === 'S' ? [{ label: this.$t('MSG_BTN_INQR'), type: 'positive' }] : [];
          items.push({
            check,
            siteId: item.siteId,
            siteName: item.siteName,
            gbmName: item.gbmName,
            taskId: item.taskId,
            taskName: item.taskName,
            userGroupId: item.userGroupId,
            userGroupName: item.userGroupName,
            requestLoginId: item.userId,
            requestUserId: item.userId,
            requestUserName: item.userName,
            requestUserGlobalName: item.userGlobalName,
            requestDsplLangId: item.displayLangId,
            requestKnoxId: item.knoxId,
            requestCompanyName: item.companyName,
            button: button,
            authRequestStatusCode: item.authRequestStatusCode,
            authRequestReason: item.authApprovalOpinionContent,
            authRejectReason: item.authApprovalOpinionContent,
            authApprDTM: apprDTM,
            authUserId: item.authApprovalUserId,
            authUserName: item.authApprovalUserName,
            authUserGlobalName: item.authApprovalUserGlobalName,
            authDsplLangId: item.authApprovalDisplayLangId,
            authKnoxId: item.authApprovalKnoxId,
            authRequestUid: item.authRequestUid,
            requestDTM: requestDTM,
            companyAuthReviewStatusCode: utils.trim(item.companyAuthReviewStatusCode),
            masterUserYn: 'N',
            validFinishDT: item.validFinishDT,
          });
        });
        this.dsData.setRawData(items);
      }).catch(error => {
        console.log(error);
      });

      return null;
    },
    onApprove() {
      this.showFinDtPopup = true;
    },
    onPopupCancelClicked() {
      this.showFinDtPopup = false;
    },
    onPopupConfirmClicked(finDt) {
      this.showFinDtPopup = false;
      const dataParams = [];
      utils.forEach(this.dsData.data, obj => {
        if (utils.isEqual(obj.check, 'Y') === true) {
          if (utils.isEqual(obj.authRequestStatusCode, 'S') === true) {
            dataParams.push(
              {
                authRequestUid: utils.trim(obj.authRequestUid),
                masterUserYn: obj.masterUserYn,
                validFinishDT: finDt.replace(/-/gi, ''),
              },
            );
          }
        }
      });

      if (dataParams.length > 0) {
        http.request(this.$options.name, 'DTS_CMA_00055', {
          data: dataParams,
        }).then(() => {
          utils.messageBox('success', this.$t('MSG_ALT_APPROVED'));
          this.onSearch();
        }).catch(error => {
          console.log(error);
        });
      } else {
        utils.messageBox('error', this.$t('MSG_ALT_NOT_SEL_ITEM'));
      }
    },
    onReject() {
      let count = 0;

      utils.forEach(this.dsData.data, obj => {
        if (utils.isEqual(obj.check, 'Y') === true) {
          if (utils.isEqual(obj.authRequestStatusCode, 'S') === true) {
            count += 1;
          }
        }
      });

      if (count > 0) {
        const inputValue = '';
        utils.openTextAreaEditor(
          this.onRejectClosePopup,
          {
            title: this.$t('MSG_TIT_AUTH_APPL_RJT_RSN'),
            pageInitialData: {
              readonly: false,
              value: inputValue,
              positiveButtonText: this.$t('MSG_BTN_CFRM'),
              negativeButtonText: this.$t('MSG_BTN_CANCEL'),
            },
          },
        );
      } else {
        utils.messageBox('error', this.$t('MSG_ALT_NOT_SEL_ITEM'));
      }
    },
    onRejectClosePopup(value) {
        if (value) {
          const dataParams = [];

          utils.forEach(this.dsData.data, obj => {
            if (utils.isEqual(obj.check, 'Y') === true) {
              if (utils.isEqual(obj.authRequestStatusCode, 'S') === true) {
                dataParams.push(
                  {
                    authRequestUid: utils.trim(obj.authRequestUid),
                    authApprovalOpinionContent: value || '',
                  },
                );
              }
            }
          });

          if (dataParams.length > 0) {
            http.request(this.$options.name, 'DTS_CMA_00053', {
              data: dataParams,
            }).then(() => {
              utils.messageBox('success', this.$t('MSG_ALT_REJECT_DATA'));
              this.onSearch();
            }).catch(error => {
              console.log(error);
            });
          } else {
            utils.messageBox('error', this.$t('MSG_ALT_NOT_SEL_ITEM'));
          }
        } else {
          utils.messageBox('error', this.$t('MSG_ALT_ROW_INPUT_CONTENT'));
        }
    },
    onClosePopup() {
    },
    onListClicked(event, item) {
      // console.log(item);
      // const taskId = utils.trim(event.taskId);
      // if (utils.isEqual(taskId, 'ALL') === true) {
      //   this.$refs.taskIdSelect.reset();
      // } else {
      //   this.$refs.taskIdSelect.setSelectedAllTask(utils.trim(event.taskId), true);
      // }
      this.applyAuthSiteId = event.key;
      this.$refs.taskIdSelect.reset(this.applyAuthSiteId);
    },
    onSelectAll(event) {
      if (utils.isEqual(event.args.datafield, 'check')) {
        if (this.dsData.data.length > 0) {
          let count = 0;
          if (this.allSelect === false) {
            utils.forEach(this.dsData.data, obj => {
              if (utils.isEqual(obj.authRequestStatusCode, 'S') === true) {
                this.dsData.setData(count, 'check', 'Y');
              }
              count += 1;
            });
            this.allSelect = true;
          } else {
            utils.forEach(this.dsData.data, obj => {
              if (utils.isEqual(obj.authRequestStatusCode, 'S') === true) {
                this.dsData.setData(count, 'check', 'N');
              }
              count += 1;
            });

            this.allSelect = false;
          }
        }
      }
    },
    /* 달력의 오류를 확인할 수 있는 validate 함수 */
    onClickValidate() {
      // if (this.onClickValidate()) return false;
      if (!this.$refs.dp.isValid()) {
        utils.messageBox('warning', this.$t('MSG_ALT_CHK_DT'), null, null);
        return true;
      }
      return false;
    },
  },
};
</script>
<style scoped>
</style>
